import React, { useState } from "react";
import emailjs from "@emailjs/browser";
import "../styles/ATMComplaintPage.css";
import AtmSupport from "../assets/photos/atm-support.png";

const ATMComplaintPage = () => {

const [formData, setFormData] = useState({
name: "",
email: "",
mobile: "",
accountLast4: "",
grievanceType: "Complaints",
grievanceCategory: "ATM - POS - ECOM",
atmLocation: "",
rrn: "",
date: "",
amount: "",
message: ""
});

const [submitted, setSubmitted] = useState(false);
const [reference, setReference] = useState("");

const handleChange = (e) => {
setFormData({
...formData,
[e.target.name]: e.target.value
});
};

const handleSubmit = (e) => {
e.preventDefault();

const ref = "ATM-" + Math.floor(10000 + Math.random() * 90000);
setReference(ref);

const templateParams = {
reference: ref,
...formData
};

emailjs.send(
"service_f5b2lp2",
"template_h5t51bu",
templateParams,
"WInhsKqhOd7H9RIa8"
)
.then(() => {
setSubmitted(true);
})
.catch((err)=>{
console.log(err);
alert("Error sending complaint");
});
};

return (

<div className="atmcomplaintpage-container">

{/* HERO */}

<section className="atmcomplaintpage-hero">

<h1>ATM Complaint & Transaction Issues</h1>

<p>
Facing issues with ATM withdrawal or card transaction?
Submit your complaint and our team will assist you quickly.
</p>

</section>


{/* FORM */}

<section className="atmcomplaintpage-form-section">

<div className="atmcomplaintpage-form-card">

{submitted ? (

<div className="atmcomplaintpage-success">
<h3>Complaint Submitted Successfully</h3>
<p>Your Reference Number</p>
<h2>{reference}</h2>
<p>Please keep this number for future communication.</p>
</div>

) : (

<div className="atmcomplaintpage-split">

{/* LEFT - FORM */}
<div className="atmcomplaintpage-form-left">

<div className="atmcomplaintpage-form-badge">
<span className="atmcomplaintpage-badge-dot"></span>
ATM / POS / ECOM — Complaints
</div>

<h2 className="atmcomplaintpage-form-title">ATM Complaint Form</h2>
<p className="atmcomplaintpage-form-sub">Submit your issue and we'll resolve it within 3 working days.</p>

<div className="atmcomplaintpage-chips">
<span className="atmcomplaintpage-chip">Grievance Type: Complaints</span>
<span className="atmcomplaintpage-chip">Category: ATM - POS - ECOM</span>
</div>

<form onSubmit={handleSubmit}>

<div className="atmcomplaintpage-grid">

<div className="atmcomplaintpage-field">
<label>Name *</label>
<input type="text" name="name" placeholder="Full name" required onChange={handleChange}/>
</div>

<div className="atmcomplaintpage-field">
<label>Email *</label>
<input type="email" name="email" placeholder="you@email.com" required onChange={handleChange}/>
</div>

<div className="atmcomplaintpage-field">
<label>Mobile No *</label>
<input type="tel" name="mobile" placeholder="+91 00000 00000" required onChange={handleChange}/>
</div>

<div className="atmcomplaintpage-field">
<label>Last 4 Digits of Account *</label>
<input type="text" name="accountLast4" placeholder="XXXX" maxLength="4" required onChange={handleChange}/>
</div>

<div className="atmcomplaintpage-field">
<label>ATM Location *</label>
<select name="atmLocation" required onChange={handleChange}>
<option value="">Select Location</option>
<option>SAH002 - Vithalwadi</option>
<option>SAH005 - Kandivali</option>
<option>SAH006 - Satara</option>
<option>SAH008 - Bhiwandi</option>
</select>
</div>

<div className="atmcomplaintpage-field">
<label>RRN</label>
<input type="text" name="rrn" placeholder="Reference number" onChange={handleChange}/>
</div>

<div className="atmcomplaintpage-field">
<label>Date of Transaction</label>
<input type="date" name="date" onChange={handleChange}/>
</div>

<div className="atmcomplaintpage-field">
<label>Amount (₹)</label>
<input type="number" name="amount" placeholder="0.00" onChange={handleChange}/>
</div>

<div className="atmcomplaintpage-field-full">
<label>Message *</label>
<textarea name="message" rows="3" placeholder="Describe the issue you faced..." required onChange={handleChange}></textarea>
</div>

</div>

<button className="atmcomplaintpage-submit-btn">Submit Complaint</button>

</form>
</div>

{/* RIGHT - IMAGE */}
<div className="atmcomplaintpage-form-right">
<img
src={AtmSupport}
alt="Bank support"
className="atmcomplaintpage-right-img"
/>
<div className="atmcomplaintpage-right-overlay">
<h3>Sahyadri Bank ATM Support</h3>
<p>Our team is here to help. Keep your transaction slip or SMS confirmation handy.</p>
</div>
</div>

</div>

)}

</div>

</section>


{/* PROCESS */}

<section className="atmcomplaintpage-process-section">

<h2>Complaint Resolution Process</h2>

<div className="atmcomplaintpage-process-grid">

<div className="atmcomplaintpage-process-card">
<h4>1</h4>
<p>Complaint Submitted</p>
</div>

<div className="atmcomplaintpage-process-card">
<h4>2</h4>
<p>Complaint Registered</p>
</div>

<div className="atmcomplaintpage-process-card">
<h4>3</h4>
<p>Verification</p>
</div>

<div className="atmcomplaintpage-process-card">
<h4>4</h4>
<p>Resolution / Refund</p>
</div>

</div>

<p className="atmcomplaintpage-process-note">
ATM complaints are generally resolved within 3 working days.
</p>

</section>


{/* INSTRUCTIONS */}

<section className="atmcomplaintpage-instructions">

<h2>Important Instructions</h2>

<div className="atmcomplaintpage-instruction-grid">

<div className="atmcomplaintpage-instruction-card">
<p>Keep the ATM transaction slip or SMS confirmation.</p>
</div>

<div className="atmcomplaintpage-instruction-card">
<p>Report ATM issues as soon as possible.</p>
</div>

<div className="atmcomplaintpage-instruction-card">
<p>Do not share your ATM PIN with anyone.</p>
</div>

<div className="atmcomplaintpage-instruction-card">
<p>Contact branch for urgent ATM issues.</p>
</div>

</div>

</section>

{/* HELPLINE */}

<section className="atmcomplaintpage-helpline">

<h2>ATM Support</h2>

<p>Email: atmsupport@sahyadribank.com</p>

<p>For urgent issues contact your nearest branch.</p>

</section>

</div>
);
};

export default ATMComplaintPage;